import { Injectable } from '@angular/core';
import Helper from '@core/helper/common.helper';
import { SessionService } from '@core/services/session.service';
import { ModulePermission, ActionRole, AdminModule } from '@modules/auth/models/user-auth.model';

@Injectable()
export class ModulePermissionService {
    private permissionList: ModulePermission[];
    private actionRole: ActionRole;

    constructor(private readonly sessionService: SessionService) {
        this.actionRole = this.configureActionRole();
    }


    getActionRoleByModule(adminModule: AdminModule): ActionRole {
        this.permissionList = Helper.getListPermission(this.sessionService, adminModule);

        if (this.permissionList.length) {
            const actions = this.permissionList[0].actions;
            this.actionRole = actions ? Helper.getRoleList(actions) : this.actionRole;
        }

        return this.actionRole;
    }

    protected configureActionRole(): ActionRole {
        return new ActionRole(true, true, true, true, true, true, true);
    }
}
